import { useEffect } from "react";

export function Seo({ title, description, schema, canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    let m = document.querySelector('meta[name="description"]');
    if (description && m) m.setAttribute("content", description);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical || `https://polizzapet.it${window.location.pathname}`;
    document.querySelectorAll("script[data-pp-schema]").forEach((n) => n.remove());
    const list = Array.isArray(schema) ? schema : schema ? [schema] : [];
    list.forEach((s) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-pp-schema", "1");
      el.textContent = JSON.stringify(s);
      document.head.appendChild(el);
    });
  }, [title, description, schema, canonical]);
  return null;
}

export const ORG_SCHEMA = {
  "@context": "https://schema.org", "@type": "Organization", name: "Polizzapet.it", url: "https://polizzapet.it",
  email: "info@polizzapet.it", description: "Confronti indipendenti e calcolatore gratuito per assicurazioni cane e gatto in Italia.",
};

export const faqSchema = (faq) => ({
  "@context": "https://schema.org", "@type": "FAQPage",
  mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});
